import Vue from 'vue'

export default Vue.extend({
  data() {
    return {
      isOpen: this.$router.history.current.hash.includes('how-it-works'),
    }
  },
})
